import { callApi } from '../common/services/baseServices';
import { host } from '../environment';
import { getCookie } from '../common/enum';
// import { dataDummy } from './data';
import {numeralFormat} from '../common/numeralFormat';

const ACTIONS_TEAM = {
    GET_INFO_PITCHERS_GAMES_SUCCESS: 'GET_INFO_PITCHERS_GAMES_SUCCESS',
    GET_INFO_PITCHERS_GAMES_ERROR: 'GET_INFO_PITCHERS_GAMES_ERROR'
};

const updateStatus = (type, data) => ({
    type,
    data,
});


const getListTeamPitchers = (id) => {
    const config = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${localStorage.getItem('ACCESS_TOKEN') || getCookie('ACCESS_TOKEN')}`,
        },
    };
    // team_id
    let url = `${host.serverTest}api/teams/${id}/pitchers`;
    return (dispatch) => {
        callApi(url, config,
            (data) => {
                dispatch(updateStatus(ACTIONS_TEAM.GET_INFO_PITCHERS_GAMES_SUCCESS, data));
            },
            (err) => {
                dispatch(updateStatus(ACTIONS_TEAM.GET_INFO_PITCHERS_GAMES_ERROR, err));
            });
    };
};

const converDataPitcher = (list) => {
    if (list) {
        const arr = list.map((value) => {
            return {
                id: value.id,
                item: [
                    { text: value.uniform_number },
                    { text: value.player_name },//選手
                    { text: value.g },
                    { text: value.cg },//試合
                    { text: value.tosho },//完投
                    { text: value.sho },//当初
                    { text: value.mushikyu },//完封
                    { text: value.w },//無四球
                    { text: value.l },//勝数
                    { text: value.sv },//負数
                    { text: value.hld },//セーブ
                    { text: value.hp },//ホールド
                    { text: value.wpct ? numeralFormat(value.wpct, 3) : value.wpct },//HP
                    { text: (value.ip_frac && value.ip_frac!=0) ? value.ip+value.ip_frac/10 : value.ip },//勝率
                    { text: value.bf },//投球回
                    { text: value.ab },//打者
                    { text: value.h },//打数
                    { text: value.hr },//被安打
                    { text: value.bb },//被本塁打
                    { text: value.hbp },//与四球
                    { text: value.so },//与死球
                    { text: value.wp },//奪三振
                    { text: value.bk },//暴投
                    { text: value.r },//ボーク
                    { text: value.er },//失点
                    { text: value.era },//自責点
                    { text: value.bb_9 },//BB/9
                    { text: value.k9 },//K/9
                    { text: value.k_bb },//K/BB
                    { text: value.whip },//WHIP
                    { text: value.comback_date },//1軍復帰
                    { is_reached_num: value.is_reached_num}
                ]
            }
        });
        return arr;
    }
}

export {
    ACTIONS_TEAM, getListTeamPitchers, converDataPitcher
};
